import { useState, useEffect } from 'react';
import { getPlayerStreaks } from '../../components/parseData';
import '../../styles/components/_playerStreaks.css';

export const PlayerStreaks = () => {
  const [streaksData, setStreaksData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStreaks = async () => {
      try {
        const data = await getPlayerStreaks();
        setStreaksData(data);
      } catch (error) {
        console.error('Error fetching player streaks:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStreaks();
  }, []);

  const formatCurrency = (value) => {
    const numValue = Number(value);
    const absValue = Math.abs(numValue).toFixed(2);
    return numValue < 0 ? `-$${absValue}` : `+$${absValue}`;
  };

  const hotPlayer = streaksData?.hotPlayer || { name: '...', winnings: null };
  const duePlayer = streaksData?.duePlayer || { name: '...', winnings: null };

  return (
    <div className="player-streaks">
      <h2 className="streaks-title">Player Streaks</h2>
      
      <div className="streaks-container">
        {/* Hot Player */}
        <div className="streak-card hot-card">
          <div className="streak-label">🔥 Hot Player 🔥</div>
          <div className="neon-box neon-red">
            <div className="player-streak-name">{hotPlayer.name}</div>
            {hotPlayer.winnings !== null && (
              <>
                <div className={`streak-winnings ${hotPlayer.winnings < 0 ? 'text-red' : 'text-green'}`}>
                  {formatCurrency(hotPlayer.winnings)}
                </div>
                <div className="streak-subtitle">in past 5 games</div>
              </>
            )}
          </div>
        </div>

        {/* Due Player */}
        <div className="streak-card due-card">
          <div className="streak-label">❄️ Due Player ❄️</div>
          <div className="neon-box neon-blue">
            <div className="player-streak-name">{duePlayer.name}</div>
            {duePlayer.winnings !== null && (
              <>
                <div className={`streak-winnings ${duePlayer.winnings < 0 ? 'text-red' : 'text-green'}`}>
                  {formatCurrency(duePlayer.winnings)}
                </div>
                <div className="streak-subtitle">in past 5 games</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};